import { Box, Paper, Typography } from '@mui/material';
import { xpCoinSrc, xpPanelBgSrc, xpPanelRibbonSrc } from '../../assets/bazzar';
import { formatAbbreviatedXp } from '../../utils/formatAbbreviatedXp';

export default function XpPanel({ totalXp = 0, expirationLabel = 'XPs have 7 day validity. Redeem Now!' }) {
  return (
    <Paper
      sx={{
        mx: 'auto',
        mb: { xs: 1.3, md: 2.2 },
        width: { xs: 300, md: 400 },
        minHeight: { xs: 108, md: 134 },
        borderRadius: '10px',
        px: 1.4,
        py: 0.9,
        backgroundImage: `url(${xpPanelBgSrc})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        textAlign: 'center',
        boxShadow: '0 5px 14px #0005',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: 1, md: 1.5 }, mb: 0.2 }}>
        <Box
          component="img"
          src={xpCoinSrc}
          alt="XP coin"
          sx={{
            width: { xs: 42, md: 60 },
            height: { xs: 45, md: 64 },
            objectFit: 'contain',
          }}
        />
        <Box sx={{ textAlign: 'left' }}>
          <Typography sx={{ color: '#000', fontWeight: 500, fontSize: 14, lineHeight: '20px', mt: 1 }}>
            Available XPs
          </Typography>
          <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: 36, lineHeight: '44px', letterSpacing: '2.5px', textTransform: 'uppercase' }}>
            {formatAbbreviatedXp(totalXp)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ position: 'relative', width: { xs: 250, md: 340 }, height: 20, mx: 'auto', mt: 0.35, mb: 1.35 }}>
        <Box component="img" src={xpPanelRibbonSrc} alt="xp validity ribbon" sx={{ width: '100%', height: '100%', display: 'block' }} />
        <Typography
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            fontSize: { xs: 8, md: 10 },
            fontWeight: 400,
            lineHeight: '12px',
            letterSpacing: 0,
          }}
        >
          {expirationLabel}
        </Typography>
      </Box>
    </Paper>
  );
}
